export default __webpack_public_path__ + "static/media/nft4.c6bb0c16.png";